export default "__VITE_ASSET__Ca0hj_Ux__"